import { translateLabel } from "@/i18n/messages";
export const DISCOVERY_BUCKET = {
  EXACT: "exact",
  CLOSEST: "closest",
  NEARBY: "nearby",
};

const mark = (park, bucket) => ({ ...park, discovery_bucket: bucket });

export const presentDiscoveryResponse = (data = {}) => {
  const exact = Array.isArray(data.parks) ? data.parks : [];
  const nearby = Array.isArray(data.other_nearby) ? data.other_nearby : [];
  const closest = data.closest ?? null;

  const seen = new Set();
  const parks = [];
  const append = (park, bucket) => {
    if (!park?.id || seen.has(park.id)) return;
    seen.add(park.id);
    parks.push(mark(park, bucket));
  };

  exact.forEach((park) => append(park, DISCOVERY_BUCKET.EXACT));
  if (closest) append(closest, DISCOVERY_BUCKET.CLOSEST);
  nearby.forEach((park) => append(park, DISCOVERY_BUCKET.NEARBY));

  return {
    ...data,
    exact_count: exact.length,
    parks,
  };
};

export const discoveryBucketLabel = (bucket) => {
  switch (bucket) {
    case DISCOVERY_BUCKET.CLOSEST: return translateLabel("Closest relevant outside radius");
    case DISCOVERY_BUCKET.NEARBY: return translateLabel("Other nearby option");
    default: return null;
  }
};
